/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
    let currentPercent = 0; // Store the current percentage globally
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.updateStatus();
      }
  
      updateStatus() {
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const rate = Shopify.currency.rate || 1;
        const threshold = Math.round(parseInt(this.dataset.shippingAmount, 10) * rate);
        const giftRaw = parseInt(this.dataset.giftAmount, 10);
        const giftThreshold = Number.isNaN(giftRaw) ? null : Math.round(giftRaw * rate);

        const remainingInfo = this.querySelector('.free-shipping__info-remaining');
        const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
        const giftInfo = this.querySelector('.free-shipping__info-gift');
        const priceInfo = this.querySelector('.free-shipping__info-price');
        const remainingAmountText = remainingInfo ? remainingInfo.querySelector('strong') : null;
        const giftRemaining = this.querySelector('[data-gift-remaining] strong');

        const currencyFormat = window.theme.settings.money_with_currency_format || '${{amount}}';
        const shippingFree = cartTotal >= threshold;
        const giftReached = giftThreshold !== null && cartTotal >= giftThreshold;

        if (remainingAmountText && !shippingFree) {
          remainingAmountText.innerHTML = formatMoney(threshold - cartTotal, currencyFormat);
        }
        if (giftRemaining && giftThreshold !== null && !giftReached) {
          giftRemaining.innerHTML = formatMoney(giftThreshold - cartTotal, currencyFormat);
        }

        // Trois etats exclusifs. Le prix du port ne s'affiche que tant qu'il est du.
        if (remainingInfo) remainingInfo.style.display = shippingFree ? 'none' : 'block';
        if (eligibilityInfo) eligibilityInfo.style.display = shippingFree && !giftReached ? 'block' : 'none';
        if (giftInfo) giftInfo.hidden = !giftReached;
        if (priceInfo) priceInfo.style.display = shippingFree ? 'none' : 'block';

        // La barre se remplit vers le palier le plus proche encore ouvert.
        const target = shippingFree && giftThreshold !== null ? giftThreshold : threshold;
        const reached = shippingFree && (giftThreshold === null || giftReached);
        this.animateProgressBar(reached ? 1 : Math.min(cartTotal / target, 1));
      }
  
      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = currentPercent;
        const duration = 200;
        const startTime = performance.now();
  
        const ease = (t) => t * (2 - t); 
  
        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);
  
          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${currentPercent}%`);
  
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            currentPercent = targetPercent; 
            this.style.setProperty('--percent', `${currentPercent}%`);
          }
        };
  
        requestAnimationFrame(animate);
      }
    }
  
    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}